import React, { PureComponent } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { Loader } from 'modules/shared'
import { getHTTPClient, checkStatusCode } from 'helpers'

class PrivateRoute extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            shouldAccess: false,
            verifying: true
        }
    }

    async componentDidMount() {
        getHTTPClient()({ method: 'POST', url: '/verify/access', data: { path: this.props.path } })
        .then(() => this.setState({ verifying: false, shouldAccess: true }) )
        .catch(error=> {
            checkStatusCode(error.response.status)
            this.setState({ verifying: false, shouldAccess: false }) 
        })
    }

	render() {
        if (this.state.verifying)
            return <Loader />
        const Component = this.props.toRender
        return <Route {...this.props} render={props => this.state.shouldAccess ? <Component {...props} /> : <Redirect to="/nao-autorizado" />	} />
	}
}

export default PrivateRoute